export const CLOUD_URL_MAT_SET = 'https://storage.googleapis.com/shina_m1_bucket/mat_sets/';
export const EURO_MAIL_LINK = 'https://evropochta.by/services/';
